// 作品頁「從每日創作長出來」指向哪一件草圖（2026-10-05）。
// 哲宇 2026-10-05：「官網我們有每件作品的建檔，這個東西要怎麼跟我們實驗室的連接起來(? 但是不要變成兩邊維護」
// ⇒ 草圖的資料以實驗室為準、正式作品以官網為準；「這件作品從哪件草圖長出來」只寫一次，寫在官網 src/data/work-details.json：
//      lineage.sketch            （作品頁沒排 blocks 時，族譜區塊掛在最後）
//      blocks 裡的 {type:'lineage', sketch}（沒寫 sketch 就用上面那個）
//    實驗室每晚讀這份（cheyuwu-lab/tools/xref/build-official-xref.mjs），不在實驗室另寫一份。
//
// 值可以是兩種，兩種都合法：
//   ・OpenProcessing 的 visualID（全是數字，例："1531809"）。既有的作品都是這種，意思不變。
//   ・實驗室的 slug（lab.cheyuwu.com/s/<slug>/ 的那段，例："261004-idea-01"）。
//       從 OpenProcessing 搬進實驗室的作品：經 lab-embeds.json 反查回 visualID，之後跟直接寫 visualID 一模一樣（同一棵族譜樹）。
//       在實驗室裡直接開的作品（沒有 visualID）：查 lab-works.json，族譜區塊改畫一張小卡連回實驗室（未公開的只寫名字、不連結）。
//   兩份對照都是 npm run lab:sync 寫的快照；執行期不打 lab。
//
// 這支不 import 任何東西：作品頁（pageWorkDetail／WorkRecord／LineageBlock）、建置腳本（build-interlinks、sync-from-lab）、
// 測試（scripts/test-lineage-ref.mjs）都用同一份，規則只有一個出處。
export const VISUAL_ID = /^\d+$/
export const LAB_SLUG = /^\d{6}[a-z]?-[a-z0-9-]+$/

// 資料裡的值 → 參照字串（數字也收；null／undefined → ''）
export const lineageRef = v => String(v ?? '').trim()

// 一件作品在 work-details 裡寫到的所有草圖參照（lineage.sketch＋每個 lineage 區塊各自的 sketch），去重、保持出現順序
export function lineageRefsOf(detail) {
  const out = []
  const add = v => { const r = lineageRef(v); if (r && !out.includes(r)) out.push(r) }
  add(detail?.lineage?.sketch)
  for (const b of detail?.blocks || []) if (b?.type === 'lineage') add(b.sketch || detail?.lineage?.sketch)
  return out
}

// embeds＝lab-embeds.json 的 items（visualID → slug）；labWorks＝lab-works.json 的 items（實驗室出生的作品）
// 回傳 (值) → { kind:'op', id }（id＝visualID，官網族譜照舊）｜{ kind:'lab', slug, work }｜{ kind:'unknown' }
export function makeLineageResolver({ embeds = {}, labWorks = [] } = {}) {
  const idOfSlug = new Map()
  for (const [id, slug] of Object.entries(embeds)) if (!idOfSlug.has(slug)) idOfSlug.set(slug, String(id))
  const born = new Map(labWorks.map(w => [w.slug, w]))
  return raw => {
    const ref = lineageRef(raw)
    if (VISUAL_ID.test(ref)) return { kind: 'op', ref, id: ref }
    if (LAB_SLUG.test(ref)) {
      if (idOfSlug.has(ref)) return { kind: 'op', ref, id: idOfSlug.get(ref), slug: ref }
      if (born.has(ref)) return { kind: 'lab', ref, slug: ref, work: born.get(ref) }
    }
    return { kind: 'unknown', ref }
  }
}
